import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/fono';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(recentBuyers[0]);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setBuyer(recentBuyers[Math.floor(Math.random() * recentBuyers.length)]);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 3000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-148" data-mp="f4vze6ku0545">
      {visible && <motion.div initial={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed right-2 top-2 z-50 w-[240px] sm:w-[265px]" role="status" aria-live="polite" data-id="element-149" data-mp="f3m23jlsz0yk">
          <div className="relative overflow-hidden rounded-lg border-2 border-coral bg-white p-2.5 pr-7 shadow-2xl" data-id="element-150" data-mp="238h75m4e2c60">
            <span className="absolute inset-x-0 top-0 h-1 bg-mustard" aria-hidden="true" data-id="element-151" data-mp="285hdzz92biy6" />
            <button type="button" onClick={() => setVisible(false)} aria-label="Close notification" className="absolute right-1 top-1.5 text-charcoal/50 transition-colors duration-150 hover:text-charcoal" data-id="element-152" data-mp="1bhkwms5swjlw">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-153" data-mp="1p8g7g9zv1as4" />
            </button>
            <div className="flex items-center gap-2.5" data-id="element-154" data-mp="rsslqz6s9l7b">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-mint text-turq" data-id="element-155" data-mp="rpxy6ysh3k9o">
                <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-156" data-mp="20216h7yzbvkr" />
              </span>
              <div className="leading-tight" data-id="element-157" data-mp="1v2y1fnj01pcs">
                <p className="text-[12px] font-extrabold text-teal" data-id="element-158" data-mp="1v1v8la249cu8">{buyer.name}</p>
                <p className="text-[10px] font-semibold text-charcoal/60" data-id="element-159" data-mp="28uky3oguszw3">
                  {buyer.location}
                </p>
                <p className="mt-0.5 text-[11px] font-bold text-coral" data-id="element-160" data-mp="24t9ga5481iyg">
                  just purchased FONO KIDS PRO™
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}